<template>
  <a-card :bordered="false">
    <s-table
      bordered
      ref="table"
      :alert="alert"
      :columns="columns"
      :data="loadData"
      :rowKey="(index) => index"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
    >
      <span slot="action" slot-scope="text,record">
        <a-popconfirm title="是否删除用令牌" @confirm="del(record)" okText="是" cancelText="否">
          <a-icon slot="icon" type="question-circle-o" style="color: red"/>
          <a href="javascript:;" style="color: red">删除</a>
        </a-popconfirm>
      </span>
    </s-table>
  </a-card>
</template>

<script>
import { fetchList, delObj } from '@api/sys/token'
export default {
  name: 'Token',
  data () {
    return {
      alert: {
        clear: true
      },
      queryParam: {},
      loadData: parameter => {
        return fetchList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res.data
        })
      },
      selectedRowKeys: [],
      selectedRows: [],
      columns: [
        {
          title: 'id',
          key: 'rowIndex',
          customRender: (text, record, index) => {
            return (
              <div>
                {index + 1}
              </div>
            )
          }
        },
        {
          title: '用户ID',
          sorter: true,
          dataIndex: 'user_id'
        },
        {
          title: '用户名',
          dataIndex: 'username'
        },
        {
          title: '令牌',
          dataIndex: 'access_token'
        },
        {
          title: '类型',
          dataIndex: 'token_type'
        },
        {
          title: '过期时间',
          dataIndex: 'expires_in'
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  methods: {
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    del (record) {
      delObj(record.access_token).then(res => {
        this.$message.info('删除成功')
        this.$refs.table.refresh(true)
      }).catch(err => {
        this.$message.error(err.msg)
      })
    }
  }
}
</script>

<style scoped>

</style>
